<template>
  <div id="app">
    <!-- Mobile Version -->
    <MobileNav class="MobileShow"/>
    <!-- Desktop Version -->
    <Showcase class="MobileHide"/>
    <div class="container">
    <div class="row">
      <div class="col MobileHide">
          <GoldenButton :text="$t('LanguageEn.myTournamentsHead')"/>
          <Tournaments/>
          <GoldenButton :text="$t('LanguageEn.myTeamsHead')"/>
          <HeaderBody/>
      </div>
    <!-- Middle Side -->
    <div class="col-7 MobileHide">
    <Navbar />
    <router-view />         
    </div>
    <!-- Right Side -->
      <div class="col MobileHide">
    <LoginP/>
    <router-link v-if="cookiesObject.token" style="text-decoration: none;" id="routerLink" :to="{ name: 'PredictionsList', params: {} }">
    <GoldenButton text="ALL GUESSES"/>
    </router-link>
    <GoldenButton v-else data-toggle="modal" data-target="#exampleModal" style="cursor: pointer;" text="ALL GUESSES"/>
     <router-link v-if="cookiesObject.token" style="text-decoration: none;" id="routerLink" :to="{ name: 'Leaderboard', params: {} }">
    <GoldenButton text="LEADERBOARD"/>
    </router-link>
    <GoldenButton v-else data-toggle="modal" data-target="#exampleModal" style="cursor: pointer;" text="LEADERBOARD"/>
    <Leagues/>
      </div>
    </div>
    <div class="footer-copyright text-center py-3 col-12 MobileHide" style="background: #010401; margin-top: 400px;">
      <div fluid style="color: grey">
         {{ $t('LanguageEn.txtCopyright') }} © {{new Date().getFullYear()}} zunisport.com | {{ $t('LanguageEn.txtAllRight') }} {{ $t('LanguageEn.txtTermsAndConditions') }} <a>
          <b-button v-b-modal.modal-F style="background: none; border: none; margin-bottom: 5px;">Zunisport.com</b-button>
          <b-modal id="modal-F" :title="$t('LanguageEn.txtTermsAndConditions')" hide-footer> 
            <p class="my-4">
              {{terms}}
              </p>
          </b-modal>
          </a>
      </div>
    </div>
    </div>
      

  </div>
</template>

<script>
import { mapActions, mapGetters} from 'vuex';
import MobileNav from './components/Mobile/MobileNav'
import Showcase from './components/Showcase'
import GoldenButton from './components/LeftColumn/GoldenButton'
import HeaderBody from './components/LeftColumn/HeaderBody'
import Tournaments from './components/LeftColumn/Tournaments'
import Navbar from './components/MiddleColumn/Navbar'
import Leagues from './components/RightColumn/Leagues'
import LoginP from './components/RightColumn/LoginP'

export default {
  name: 'App',
  data(){
    return {
      cookiesObject: '',
      terms: '',
      poId: 1,
      laId: 1,
    }
  },

  methods: {
      ...mapActions(["getArray"]),
  },
  components: {
    MobileNav,
    Showcase,
    GoldenButton,
    HeaderBody,
    Navbar,
    Leagues,
    LoginP,
    Tournaments,
  },

  async created(){

    var cookiesObject = document.cookie.split(';').map(cookie => cookie.split('=')).reduce((accumulator, [key, value]) => ({...accumulator, [key.trim()]: decodeURIComponent(value)}),{});
    this.cookiesObject = cookiesObject;
  
    if (!cookiesObject.langId) {
      document.cookie = 'langId = 1';
    }

    if (cookiesObject.portalId) {
          console.log('portal ID identified')
    } else {

    if (cookiesObject.token) {
    const res = await fetch('https://sportapi.zuniac.com/general/appData?token=' + this.cookiesObject.token);
    const data = await res.json();
    const portalId = data.portal.id;
    const countryCode = data.portal.countryCode;

    document.cookie = 'portalId =' + portalId;
    document.cookie = 'countryCode =' + countryCode;

    
    location.reload();
        
      } else {
     const res = await fetch('https://sportapi.zuniac.com/general/appData');
    const data = await res.json();
    const portalId = data.portals[0].id;
    const countryCode = data.portals[0].countryCode;

    document.cookie = 'portalId =' + portalId;
    document.cookie = 'countryCode =' + countryCode;
    document.cookie = 'langId = ' + data.portals[0].params.default_language;
    document.cookie = 'regText = ' + data.portals[0].params.show_registration_intro_text;
    document.cookie = 'lang = ' + data.portals[0].params.default_lang_code;

    location.reload();
      }
      
    }
  },

  async beforeMount(){
    if (this.cookiesObject.token) {
        this.getArray();
    }
    
    var myHeaders = new Headers();
    myHeaders.append("Cookie", "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765");

    var requestOptions = {
          method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(this.httpReq +"/general/page?languageId="+this.cookiesObject.langId+"&link=terms&portalId="+ this.cookiesObject.portalId, requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.text) {
        this.terms = result.text
        } else{
        this.terms = 'No information at the moment';
        }
        
        })
      .catch(error => console.log('error', error));
  },
  computed: {
   ...mapGetters(['httpReq']),

  },  
}
</script>

<style>
body{
    background: #000000;
    height: 100%;
    width: 100%;
}

.minWidth{
  min-width: 600px;
}

@media only screen and (max-width: 770px) {
  body{
    background: #212529;
  }
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}
</style>
